import { TextMessage } from './TextMessage'
import { ChatMessage, MessageTypeEnum } from 'types/chat-message'
import { useGetSetting } from 'api/settings'

export type BotMessageProps = {
  messageItem: ChatMessage
  index: number
}

export const BotMessage = ({ messageItem, index }: BotMessageProps) => {
  const { title } = useGetSetting()

  if (messageItem.type !== MessageTypeEnum.TEXT) return null

  return (
    <TextMessage senderName={title} text={messageItem.message} messageItem={messageItem} isFirstMessage={index === 0} />
  )
}
